import React from 'react'
import HeadingOfSections from './HeadingOfSection';
import { useTranslation } from 'react-i18next';
import frigopic from '../Assets/frigopic.webp'
import servicelogo from '../Assets/whitelogo.png'
import arrowright from '../Assets/arrowright.png'
import { Link } from 'react-router-dom';
import styles from '../styles.js';
import { FaArrowRightLong } from "react-icons/fa6";
import { FaCircleCheck } from "react-icons/fa6";

const StockFrigo = (props) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    return (
    <div className={`${props.motherclassName} ${props.classmarginbottom} ${props.padd} ${isRTL ? 'rtl' : 'ltr'}`}>
    <div className={`${props.className3} `}>
        <div className="relative bg-white w-full xl:w-[90%] xxl:w-[85%] xxxl:w-[80%]  aspect-[9/11] rounded-tl-[50px] rounded-br-[50px] ">                        
                <img
                src={frigopic}
                alt="Cold Storage Truck"
                className="object-cover w-full h-full rounded-tl-[30px] rounded-br-[30px] sm:rounded-tl-[50px] sm:rounded-br-[50px] rounded-tr-[100px] rounded-bl-[85px] sm:rounded-tr-[150px] sm:rounded-bl-[100px]"
                />
                {/* Circle with logo */}
                <div className='shapestr '></div>
                <div className=" absolute
                    -top-[75px] -right-[135px] w-0 h-0 rotate-[145deg]
                    sm:-top-[120px] sm:-right-[185px]  
                    border-r-[100px] border-r-white border-t-[100px] border-t-transparent border-l-[100px] border-l-transparent border-b-[100px] border-b-transparent
                    sm:border-r-[150px] sm:border-r-white sm:border-t-[150px] sm:border-t-transparent sm:border-l-[150px] sm:border-l-transparent sm:border-b-[150px] sm:border-b-transparent">
                </div>
                {/* Circle with logo */}
                <div className=" absolute bg-white rounded-full h-[100px] sm:h-[180px] xxxl:h-[200px] aspect-square top-8 sm:top-4 xxxl:top-8 right-0 sm:-right-4 z-20 flex justify-center items-center p-2 sm:p-3">
                    <div className="bg-red-600 rounded-full w-full aspect-square flex items-center justify-center">
                        <img src={servicelogo} alt='logo' className=' w-10 sm:w-20 aspect-square' />
                    </div>
                </div>
                <div className='shapesbl '></div>
                <div className="absolute z-10 
                -bottom-[80px] -left-[135px]
                sm:-bottom-[130px] sm:-left-[185px] w-0 h-0 -rotate-[35deg]  
                border-r-[100px] border-r-white border-t-[100px] border-t-transparent border-l-[100px] border-l-transparent border-b-[100px] border-b-transparent
                sm:border-r-[150px] sm:sm:border-r-white sm:border-t-[150px] sm:border-t-transparent sm:border-l-[150px] sm:border-l-transparent sm:border-b-[150px] sm:border-b-transparent">
                </div>
                <div className=" absolute bottom-0 w-full h-full bg-gradient-to-t from-secondary via-transparent to-transparent z-[1] rounded-bl-[85px] sm:rounded-tr-[150px] rounded-br-[30px] sm:rounded-br-[50px] "></div>
        
            {/* Bottom text block */}
            <div className={`absolute ${props.classbottom} right-[10px] sm:right-[20px] py-3 sm:py-5 bg-transparent text-white w-[calc(100%-120px)] sm:w-[calc(100%-180px)] text-center z-50 flex  items-center justify-center `}>
                <div className='absolute w-full h-[calc(100%-50px)] bg-primary
                    after:absolute after:bg-secondary after:h-full after:w-[2px] after:-top-2 after:-left-3 after:rounded-l-full
                    before:absolute before:bg-secondary before:h-full before:w-[2px] before:bottom-[7px] before:right-[12px] before:rounded-r-full before:z-[20]'></div>
                <div className='absolute top-0 right-0 w-full after:absolute after:bg-secondary after:h-[2px] after:w-full after:-top-2 after:-left-3 after:rounded-t-full rounded-t-full h-0 z-10 border-r-[20px]  border-r-transparent border-l-[20px] border-l-transparent border-b-[25px] border-b-primary'>
                    <div className='absolute w-[35px] h-[35px] -top-[2px] -left-[26px] border-l-secondary border-l-[2px] rounded-[4px] rotate-[38deg] bg-transparent '></div>
                    <div className='absolute w-[35px] h-[35px] -top-[2px] -right-[2px] border-t-secondary border-t-[2px] rounded-[4px] rotate-[52deg] bg-transparent '></div>
                </div>
                <div className='absolute bottom-0 right-0 w-full h-0 after:absolute after:bg-secondary after:h-[2px] after:w-full after:-bottom-2 after:left-3 after:rounded-b-full z-10 rotate-180 border-r-[20px]  border-r-transparent border-l-[20px] border-l-transparent border-b-[25px] border-b-primary'>
                    <div className='absolute w-[35px] h-[35px] top-[12px] -left-[2px] border-l-secondary border-l-[2px] rounded-[4px] rotate-[38deg] bg-transparent '></div>
                    <div className='absolute w-[35px] h-[35px] top-[12px] -right-[26px] border-t-secondary border-t-[2px] rounded-[4px] rotate-[52deg] bg-transparent '></div>
                </div>

                <div className={`z-20 mx-auto flex justify-center items-center ${props.classwidth}`}>
                <h1 className={`my-0 z-20 w-full ${props.classText1} text-start`}>{t('homepage.servicesection.StockageFrigo.pitureheader1')}  <span className='font-normal'>{t('homepage.servicesection.StockageFrigo.pitureheader2')} </span>{t('homepage.servicesection.StockageFrigo.pitureheader3')}</h1>
                </div>
            </div>
    
        </div>
    </div>
    <div className={`section2 ${props.className2} flex flex-col gap-6 xl:gap-8 xxl:gap-10 xxxl:gap-12 justify-center items-start`}>
        <div className="flex justify-start items-center gap-5">
            <img src={arrowright} alt="arrow right" className={`h-6 ${isRTL && 'rotate-180'}`} loading="lazy"/>
            <h1 className="my-0 text-primary font-bold text-[20px]  md:text-[25px] lg:text-[30px] xl:text-[40px] xxl:text-[45px]">{t('homepage.servicesection.StockageFrigo.title1')}</h1>
        </div>
        <h1 className={`my-0 text-primary02 font-bold w-[90%] text-start ${props.classSectionText1}`}>{t('homepage.servicesection.StockageFrigo.title2')}</h1>
        <div className="flex flex-col justify-center items-start gap-6">
            <h1 className={`my-0 text-secondary font-bold  w-full ${props.classSectionText2}`}>"{t('homepage.servicesection.StockageFrigo.title3')}"</h1>
            <p className={`w-[90%] text-start  ${props.classSectionText3} text-paragraph`}>{t('homepage.servicesection.StockageFrigo.description')}</p>
        </div>
        <div className="flex flex-col gap-6 justify-center items-start">
            <div className='flex gap-4 items-center'>
                <FaCircleCheck size={30} fill="#F99F00" className='text-white'/>
                <p className={`w-full text-start font-semibold ${props.classSectionText4} text-primary02`}>{t('homepage.servicesection.StockageFrigo.types.title1')}</p>
            </div>
            <div className='flex gap-4 items-center'>
                <FaCircleCheck size={30} fill="#F99F00" className='text-white'/>
                <p className={`w-full text-start font-semibold ${props.classSectionText4} text-primary02`}>{t('homepage.servicesection.StockageFrigo.types.title2')}</p>
            </div>
            <div className='flex gap-4 items-center'>
                <FaCircleCheck size={30} fill="#F99F00" className='text-white'/>
                <p className={`w-full text-start font-semibold ${props.classSectionText4} text-primary02`}>{t('homepage.servicesection.StockageFrigo.types.title3')}</p>
            </div>
        </div>
        <div className={`flex w-auto items-center justify-end z-40`}>
            <button className={`${styles.primaryBotton} rounded-full`}>
                <Link to={'contact'} smooth duration={50} className='flex justify-center items-center gap-4 px-3 py-1'>
                {t('contact.callus')}
                <FaArrowRightLong size={20} className={`text-white ${isRTL && 'rotate-180'}`}/>
                </Link>
            </button>
        </div>
    </div>
</div>
  )
}

export default StockFrigo